export * from "/__w/wiggot-web/wiggot-web/packages/web-components/services/properties.services.ts"